// The build this tab is currently running. Injected by vite.config.ts's
// `define`, from the same value the same build wrote to dist/version.json —
// so a match here is a guarantee the tab is on the build it fetched.
export const CURRENT_BUILD_ID = import.meta.env.VITE_APP_BUILD_ID

// Matches the account-activity ping cadence (use-session-activity-ping.ts) —
// no reason for this to poll on its own, tighter schedule.
export const POLL_INTERVAL_MS = 5 * 60 * 1000

interface VersionFile {
  buildId?: unknown
}

// Client-side routing never re-fetches index.html, so nothing else ever
// tells a long-lived tab a new build exists. cache: "no-store" plus a
// cache-busting query param both matter here — this file is deployed with
// no-cache response headers (see the deploy workflows), but a stale
// intermediate proxy or an overzealous browser cache is exactly the failure
// mode this poll exists to see past.
export const fetchLatestBuildId = async (): Promise<string | null> => {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store"
    })
    if (!response.ok) return null

    const data = (await response.json()) as VersionFile
    return typeof data?.buildId === "string" ? data.buildId : null
  } catch {
    // Offline or the request itself failed — says nothing about whether a
    // new version exists, so this is not "no update", it is "unknown".
    return null
  }
}

export const isNewVersionAvailable = (latestBuildId: string | null): boolean =>
  !!latestBuildId && latestBuildId !== CURRENT_BUILD_ID
